import { useRouter, useRoute } from 'vue-router'
import {
  ref,
  getCurrentInstance,
  onMounted,
  onBeforeUnmount,
} from 'vue'
import {
  // storeReadProgress,
  getMaterialPlayToken,
} from '@/api/modules/course'
import {
  getOneArticle
} from '@/api/modules/note'
import { userLoginInfo } from '@/api/modules/login'
export default function () {
  let $route = useRoute()
  let $router = useRouter()
  let origin = $route.query.origin
  let goodsType = $route.query.goodsType
  let goodsId = $route.query.goodsId
  let adminId = $route.query.adminId
  let resourceId = $route.query.resourceId
  let id = $route.query.id
  // 视频 //id: 1675 resourceId:97 // 音频 //id: 1718 resourceId:97

  const currentInstance = getCurrentInstance()
  const global = currentInstance.appContext.config.globalProperties

  const sourceUrl = ref('')
  const article = ref({})
  const showLoading = ref(false)

  let player = ref(null)
  let hlsURL = ''
  let currentStream = ref({})
  let MtsHlsUriToken = ''
  let readVersion = 0
  const getPlayToken = async () => {
    if (hlsURL) {
      let data = await getMaterialPlayToken(id)
      MtsHlsUriToken = data.data
      // let source hlsURL+'?'+'MtsHlsUriToken'+'='+MtsHlsUriToken
      sourceUrl.value = hlsURL + '?MtsHlsUriToken=' + MtsHlsUriToken
      initPlay()
    } else {
      global.$toaster({
        message: '获取播放源失败',
      })
    }
  }
  // 仅仅记录音视频的播放进度
  const storeStudyProgress = async function (textValue) {
    await storeReadProgress({
      articleId: id,
      articleRemainId: article.value.articleRemainId,
      mediaValue: player.value.getCurrentTime(),
      resourceId: resourceId,
      textValue: textValue ? textValue : 0, //不记录文稿
      type: goodsType,
      ver: readVersion,
    })
    readVersion += 1
  }
  const initPlay = () => {
    player.value = new Aliplayer(
      {
        id: 'J_prismPlayer',
        source: sourceUrl.value,
        format: 'm3u8',
        mediaType: 'audio',
        width: '100%',
        // height: 422 * this.ratio + 'px',
        height: '100%',
        autoplay: false,
        isLive: false,
        rePlay: false,
        playsinline: true,
        preload: true,
        controlBarVisibility: 'click',
        useH5Prism: true,
        cover: article.value.materialCoverImage,
      },
      function (player) {
        console.log('The player is created')
      }
    )
    player.value.on('completeSeek', () => {
      // storeStudyProgress()
      document.getElementsByClassName('prism-thumbnail')[0].style.display =
        'none'
    });
    // player.value.on('ended', () => {
    //   storeStudyProgress()
    // })
    // player.value.on('pause', () => {
    //   storeStudyProgress()
    // })
    // player.value.on('canplay', () => {
    //   storeStudyProgress()
    //   // console.log('canplay canplay canplay')
    // })
  }
  const getArticle = async (data) => {
    showLoading.value = true
    let res = await getOneArticle(data)
    showLoading.value = false
    if (res && res.code == 200) {
      article.value = res.data
      readVersion = res.data.readVersion
      if (article.materialType == global.constants.materialType.text) return
      if (
        Object.prototype.toString.call(res.data.streamInfos) ==
        '[object Array]'
      ) {
        currentStream.value = selectDefinition(res.data.streamInfos)
        hlsURL = currentStream.value.hlsURL
        if (article.value.materialType != global.constants.materialType.text) {
          getPlayToken()
        }
      }
    }
  }
  // 清晰度 FD（流畅）LD（标清）SD（高清）HD（超清）OD（原画）2K（2K）4K（4K）
  const selectDefinition = (arr, def = 'SD') => {
    let currentStream = null
    arr.forEach((it) => {
      if (it.definition.toUpperCase() === def.toUpperCase()) {
        currentStream = it
        return
      }
    })
    if (currentStream == null) {
      return arr[0]
    }
    return currentStream
  }

  const isLogin = async () => {
    let res = await userLoginInfo()
    if (res && res.code == 200) {
      let data = {
        id,
        type: goodsType,
        resourceId,
      }
      getArticle(data)
    }
  }

  onMounted(() => {
    // isLogin()
    getArticle(id)
  })

  onBeforeUnmount(() => {
    player instanceof Aliplayer && player.pause()
  })

  return {
    player,
    article,
    resourceId,
    goodsType,
    goodsId,
    showLoading,
    currentStream,
    storeStudyProgress,
  }
}